import styled from 'styled-components';

const StyledHeader = styled.div`
    font-family: 'Helvetica', 'Arial', sans-serif;
    font-size: 24px;
    color: ${global.Gray1};
    margin-top: 15px;
    margin-bottom: 15px;
    font-weight: 500;
    white-space: nowrap;
`;

export default StyledHeader;
